import { useBackend } from '@cdab/scania/qpr/contexts/backend-provider'

export type SetChatMessageAsUnReadByAuditorStatus =
  | 'success'
  | 'error'
  | 'loading'
  | 'none'

export function useSetChatMessageAsUnReadByAuditor() {
  const client = useBackend()

  const handleClickSetChatMessageAsReadByAuditor = async (
    messageId: number
  ) => {
    try {
      await client.AuditsService.SetChatMessagesAsUnReadByAuditor(messageId)
    } catch (e) {
      console.error(e)
    }
  }

  return [handleClickSetChatMessageAsReadByAuditor] as const
}
